const { default: api } = require("config/axios");
export const getCertificateTypeList = () => api.get("/certificate-types");
